import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Keyboard, Mouse } from 'lucide-react';
interface PreferenceScreenProps {
  onSelectGuidedTour: () => void;
  onSelectMouseKeyboard: () => void;
}
export function PreferenceScreen({
  onSelectGuidedTour,
  onSelectMouseKeyboard
}: PreferenceScreenProps) {
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900" data-id="element-473">
      {/* Background */}
      <div className="absolute inset-0" data-id="element-474">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-20 blur-md" data-id="element-475" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 to-slate-900/80" data-id="element-476" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-8" data-id="element-477">
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-5xl font-light text-white uppercase tracking-[0.3em] mb-20" data-id="element-478">
          Select Preference
        </motion.h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl w-full" data-id="element-479">
          {/* Guided Tour */}
          <motion.button initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} onClick={onSelectGuidedTour} className="group relative bg-slate-800/40 backdrop-blur-sm rounded-2xl p-12 border border-white/10 hover:border-white/30 transition-all hover:bg-slate-800/60" data-id="element-480">
            {/* Icon */}
            <div className="mb-8 flex justify-center" data-id="element-481">
              <div className="relative" data-id="element-482">
                <MapPin className="w-16 h-16 text-white/80" strokeWidth={1.5} data-id="element-483" />
                <svg className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-32 h-8" viewBox="0 0 100 20" data-id="element-484">
                  <path d="M 10,10 Q 30,0 50,10 T 90,10" stroke="white" strokeWidth="1" strokeDasharray="4,4" fill="none" opacity="0.4" data-id="element-485" />
                  <circle cx="10" cy="10" r="3" fill="white" opacity="0.6" data-id="element-486" />
                  <circle cx="90" cy="10" r="3" fill="white" opacity="0.6" data-id="element-487" />
                </svg>
              </div>
            </div>

            {/* Title */}
            <h2 className="text-3xl font-light text-white uppercase tracking-wider mb-4" data-id="element-488">
              Guided Tour
            </h2>

            {/* Description */}
            <p className="text-white/60 text-sm leading-relaxed" data-id="element-489">
              Sit back and enjoy a guided tour of the home, no controls
              required.
            </p>
          </motion.button>

          {/* Mouse + Keyboard */}
          <motion.button initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} onClick={onSelectMouseKeyboard} className="group relative bg-slate-800/40 backdrop-blur-sm rounded-2xl p-12 border border-white/10 hover:border-white/30 transition-all hover:bg-slate-800/60" data-id="element-490">
            {/* Icon */}
            <div className="mb-8 flex justify-center gap-4" data-id="element-491">
              <Keyboard className="w-16 h-16 text-white/80" strokeWidth={1.5} data-id="element-492" />
              <Mouse className="w-16 h-16 text-white/80" strokeWidth={1.5} data-id="element-493" />
            </div>

            {/* Title */}
            <h2 className="text-3xl font-light text-white uppercase tracking-wider mb-4" data-id="element-494">
              Mouse + Keyboard
            </h2>

            {/* Description */}
            <p className="text-white/60 text-sm leading-relaxed" data-id="element-495">
              Take full control to walk through the home and inspect every
              detail yourself.
            </p>
          </motion.button>
        </div>
      </div>
    </div>;
}